export default function wrap(element) {
  function contains(el) {
    if (element === el) {
      return true;
    }

    if (!el.parentElement) {
      return false;
    }

    return contains(el.parentElement);
  }

  return { contains };
}



// WEBPACK FOOTER //
// ./app/lib/domHelpers.js